import React from "react";
import Container from "@/components/marketing/Container";
import MarqueeLogo from "@/components/marketing/MarqueeLogo";

export default function SectorTrustBadges({ svgLogos = [], textLogos = [], label = "Distributed to 500+ outlets including" }) {
  if (svgLogos.length === 0 && textLogos.length === 0) return null;

  return (
    <section className="py-10 lg:py-12 border-y border-border bg-slate/30">
      <Container>
        <p className="font-mono text-xs uppercase tracking-widest text-steel text-center mb-8">
          {label}
        </p>
        {svgLogos.length > 0 && (
          <div className="overflow-hidden relative mb-6">
            <div className="flex w-max animate-ticker hover:[animation-play-state:paused] motion-reduce:w-full motion-reduce:flex-wrap motion-reduce:justify-center motion-reduce:animate-none">
              <div className="flex shrink-0 items-center gap-x-10 lg:gap-x-14 pr-10 lg:pr-14 motion-reduce:w-full motion-reduce:flex-wrap motion-reduce:justify-center motion-reduce:pr-0">
                {svgLogos.map((logo, i) => (
                  <MarqueeLogo key={`a-${i}`} src={logo.src} name={logo.name} scale={logo.scale || 1} />
                ))}
              </div>
              <div className="flex shrink-0 items-center gap-x-10 lg:gap-x-14 pr-10 lg:pr-14 motion-reduce:hidden" aria-hidden="true">
                {svgLogos.map((logo, i) => (
                  <MarqueeLogo key={`b-${i}`} src={logo.src} name={logo.name} scale={logo.scale || 1} />
                ))}
              </div>
            </div>
          </div>
        )}
        {textLogos.length > 0 && (
          <div className="flex flex-wrap items-center justify-center gap-3 lg:gap-4">
            {textLogos.map((name) => (
              <span
                key={name}
                className="font-heading text-sm lg:text-base font-semibold text-[#8b8fa3] hover:text-bone transition-colors duration-300 px-3 py-1.5"
              >
                {name}
              </span>
            ))}
          </div>
        )}
      </Container>
    </section>
  );
}